export  enum  MemberLevel  {
    RETAIL = 1,
    PREFERREDCUSTOMER = 2,
    ASSISTANTSUPERVISOR = 3,
    SUPERVISOR = 4,
    ASSISTANTMANAGER = 5,
    MANAGER = 6,
    UNRECOGNIZEDMANAGER = 7,
    RECOGNIZEDMANAGER = 8,
    SENIORMANAGER = 9,
    SOARINGMANAGER = 10,
    SAPPHIREMANAGER = 11,
    DIAMONDSAPPHIREMANAGER = 12,
    DIAMONDMANAGER = 13,
    DOUBLEDIAMONDMANAGER = 14,
    TRIPLEDIAMONDMANAGER = 15,
    DIAMONDCENTURIONMANAGER = 16,
    NOVUSCUSTOMER = 17
}
